import { GridBox } from '@components/grid-box';
import { Image } from '@components/image';
import { getFormattedDateToNowString } from '@components/typography';
import { Workspace } from '@generated/graphql';
import { memo } from 'react';

type LandingPageWorkspaceCardProps = Partial<Workspace> & {
  expired: boolean;
  onClick?: () => void;
};

export const LandingPageWorkspaceCard = memo(
  ({
    name,
    status,
    updatedAt,
    previewThumbnail,
    expired,
    onClick,
  }: LandingPageWorkspaceCardProps) => {
    const title = `${name}${status !== 'ready' ? ' (Syncing)' : ''}` || '...';
    const description = getFormattedDateToNowString({
      date: updatedAt,
      formatOptions: { includeSeconds: true },
    });
    return (
      <GridBox
        sx={{ height: '100%', width: '100%' }}
        title={title}
        description={description}
        onClick={onClick}
        disabled={expired}
        content={<Image url={previewThumbnail} />}
      />
    );
  },
);
